module.exports = __webpack_public_path__ + "img/bg-nosotros-4.5510c67f.png";